import React from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import './Confirmation.css';
import BackButton from './Backbutton';

const HEADINGS = {
  yes: { emoji: '🎉', title: "You're in!", note: "We can't wait to bounce with you." },
  maybe: { emoji: '🤞', title: 'Fingers crossed!', note: 'Hope you can make it — tell us if things change.' },
  no: { emoji: '💛', title: "We'll miss you!", note: 'Thanks for letting us know.' }
};

const RESPONSE_LABEL = {
  yes: "Yes, we'll be there!",
  maybe: "Maybe, we'll try our best!",
  no: "Sorry, we can't make it."
};

function plural(n, word) {
  return `${n} ${word}${Number(n) === 1 ? '' : 's'}`;
}

function formatParty(adults, kids) {
  const parts = [];
  if (adults != null) parts.push(plural(adults, 'adult'));
  if (kids != null && Number(kids) > 0) parts.push(plural(kids, 'kid'));
  return parts.join(', ') || '—';
}

function buildCalendarUrl(pd) {
  if (!pd || !pd.calendarStart || !pd.calendarEnd) return null;
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: `Advait's ${pd.age}th Birthday — ${pd.locationName}`,
    dates: `${pd.calendarStart}/${pd.calendarEnd}`,
    ctz: 'America/Los_Angeles',
    location: `${pd.locationName}, ${pd.locationAddress}`,
    details: 'Socks required to play. Please arrive 15 minutes early to sign the waiver.'
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

const Confirmation = ({ partyDetails }) => {
  const location = useLocation();
  const rsvp = location.state && location.state.rsvp;

  // Reached without submitting (refresh, direct link, bookmark).
  if (!rsvp) return <Navigate to="/rsvp" replace />;

  const heading = HEADINGS[rsvp.attendance] || HEADINGS.yes;
  const going = rsvp.attendance === 'yes' || rsvp.attendance === 'maybe';
  const calendarUrl = going ? buildCalendarUrl(partyDetails) : null;

  return (
    <main className="confirm-main">
      <BackButton />

      <section className="card confirm-card">
        <div className="confirm-emoji" aria-hidden="true">{heading.emoji}</div>
        <h2>{heading.title}</h2>
        <p className="confirm-note">Thanks, {rsvp.name}. {heading.note}</p>

        <dl className="confirm-recap">
          <div>
            <dt>Your response</dt>
            <dd>{RESPONSE_LABEL[rsvp.attendance]}</dd>
          </div>
          {going && (rsvp.adults != null || rsvp.kids != null) && (
            <div>
              <dt>Coming</dt>
              <dd>{formatParty(rsvp.adults, rsvp.kids)}</dd>
            </div>
          )}
          {going && rsvp.email && (
            <div>
              <dt>Waiver email</dt>
              <dd>{rsvp.email}</dd>
            </div>
          )}
        </dl>

        {going && (
          <>
            <div className="confirm-party">
              <h3>{partyDetails.date}</h3>
              <p>{partyDetails.time}</p>
              <p>
                {partyDetails.locationName}<br />
                {partyDetails.locationAddress}
              </p>
            </div>

            {calendarUrl && (
              <a className="confirm-cal" href={calendarUrl} target="_blank" rel="noopener noreferrer">
                Add to Google Calendar
              </a>
            )}

            <p className="confirm-reminder">
              🧦 Bring socks for every jumper and arrive 15 minutes early to sign the waiver.
            </p>
          </>
        )}

        <Link to="/" className="confirm-home">Back to the invitation</Link>
      </section>
    </main>
  );
};

export default Confirmation;
